import CanvasGame from './src/canvas-game'

export default CanvasGame;
